import * as React from "react";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";
import Environment from "nexia_mobile/environment";
import traneCommercialLogo from "nexia_mobile/styl/images/trane_commercial_logo.svg";
import amstdCommercialLogo from "nexia_mobile/styl/images/amstd_commercial_logo.svg";
import prefixStyles from "nx-components/utils/prefixStyles";

const isTrane = Environment.isTraneCommercial();
const styles = prefixStyles({
  maskStyle: {
    backgroundColor: "#60ae33",
    WebkitMaskSize: "cover",
    maskSize: "cover",
  },
  commercialDiv: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
  },
});

const PivotLockScreenBrandLogo = () => {
  return (
    <DarkModeInverter>
      {({ maybeInvert }) => {
        return (
          <div
            data-component-name="PivotLockScreenBrandLogo"
            style={{ ...maybeInvert, ...styles.commercialDiv }}
          >
            <span
              style={{
                ...styles.maskStyle,
                maskImage: `url(${
                  isTrane ? traneCommercialLogo : amstdCommercialLogo
                })`,
                WebkitMaskImage: `url(${
                  isTrane ? traneCommercialLogo : amstdCommercialLogo
                })`,
                width: isTrane ? "13em" : "14em",
                height: isTrane ? "4.5em" : "3.5em",
              }}
            />
          </div>
        );
      }}
    </DarkModeInverter>
  );
};

export default PivotLockScreenBrandLogo;



// WEBPACK FOOTER //
// ./src/components/BrandLogo/PivotLockScreenBrandLogo.jsx